'use strict';

var _ = require('lodash');
var DataRetrieverService = function DataRetrieverService(DataRetriever, dataRetrieverDefinitions) {
  var entitiesKey = [];
  function getEntityKey(options) {
    return options.screen + '-' + options.mode + '-' + options.targetType;
  }
  var memoizedGetDataRetrieverInstance = _.memoize(function (options) {
    entitiesKey.push(getEntityKey(options));
    return new DataRetriever(options);
  }, getEntityKey);
  function getDataRetriever(screen, mode, targetType) {
    return memoizedGetDataRetrieverInstance({
      screen: screen,
      mode: mode,
      targetType: targetType
    });
  }
  function findDataRetrievers(screen, mode, targetType) {
    var argumentsToMatch = _.filter(arguments, _.isString).length;
    return _.chain(entitiesKey).transform(function (result, key) {
      return result.push(memoizedGetDataRetrieverInstance.cache.get(key));
    }).filter(function (dataRetriever) {
      var conditions = [];
      conditions.push(dataRetriever.screen() === screen);
      conditions.push(dataRetriever.mode() === mode);
      conditions.push(dataRetriever.targetType() === targetType);
      return _.every(conditions.slice(0, argumentsToMatch));
    }).value();
  }
  function resetBrushFilters(screen, mode, targetType) {
    findDataRetrievers(screen, mode, targetType).forEach(function (dataRetriever) {
      dataRetriever.resetBrushFilters();
    });
  }
  function gridSortApplied(currentSortOrder, screen, mode, targetType) {
    findDataRetrievers(screen, mode, targetType).forEach(function (dataRetriever) {
      dataRetriever.gridSortApplied(currentSortOrder);
    });
  }
  function setBrushFilters(brushFilters, screen, mode, targetType) {
    findDataRetrievers(screen, mode, targetType).forEach(function (dataRetriever) {
      dataRetriever.brushFilters(brushFilters);
    });
  }
  function updateMetricValues(metric, screen, mode, targetType) {
    findDataRetrievers(screen, mode, targetType).forEach(function (dataRetriever) {
      dataRetriever.updateMetricValues(metric);
    });
  }
  function setScenarios(scenarios, screen, mode, targetType) {
    findDataRetrievers(screen, mode, targetType).forEach(function (dataRetriever) {
      dataRetriever.scenarios(scenarios);
    });
  }
  function setDataFlow(dataFlow, screen, mode, targetType) {
    findDataRetrievers(screen, mode, targetType).forEach(function (dataRetriever) {
      dataRetriever.dataFlow(dataFlow);
    });
  }

  //add functionality to be able to set a dataRetriever
  function setDataRetriever(options, dataRetriever) {
    memoizedGetDataRetrieverInstance.cache.set(getEntityKey(options), _.cloneDeep(dataRetriever));
  }
  function initializeDataRetrievers() {
    dataRetrieverDefinitions.forEach(function (retrieverConfiguration) {
      memoizedGetDataRetrieverInstance(retrieverConfiguration);
    });
  }
  initializeDataRetrievers();
  return {
    getDataRetriever: getDataRetriever,
    findDataRetrievers: findDataRetrievers,
    resetBrushFilters: resetBrushFilters,
    gridSortApplied: gridSortApplied,
    setBrushFilters: setBrushFilters,
    updateMetricValues: updateMetricValues,
    setScenarios: setScenarios,
    setDataFlow: setDataFlow,
    setDataRetriever: setDataRetriever
  };
};
DataRetrieverService.$inject = ['DataRetrieverFactory', 'DataRetrieverDefinitions'];
module.exports = DataRetrieverService;